import debounce from 'lodash/debounce';

function revealReadmore(trigger, target) {
  trigger.classList.remove('u-hidden');
  target.classList.remove('o-readmore--active');
}

function hideReadmore(trigger, target) {
  trigger.classList.add('u-hidden');
  target.classList.add('o-readmore--active');
}

export default function setupReadMore() {
  const triggers = document.querySelectorAll('.js-readmore');

  Array.from(triggers).forEach((trigger) => {
    const targetId = trigger.getAttribute('href');
    const target = document.querySelector(targetId);

    if (target) {
      let hidden = null;
      let mq = null;

      // Check if we want to hide from a certain point and setup a mq for it
      if (trigger.getAttribute('data-show-until')) {
        hidden = trigger.getAttribute('data-show-until');
        mq = window.matchMedia(`(min-width: ${hidden}px)`);
      }

      // if we didn't set a hidden OR we did and the media query matches
      if (hidden === null || (hidden && !mq.matches)) {
        revealReadmore(trigger, target);
      }

      if (hidden) {
        window.onresize = debounce(() => {
          if (mq.matches) {
            hideReadmore(trigger, target);
          } else {
            revealReadmore(trigger, target);
          }
        }, 200);
      }

      // add a click event to the link to toggle the read more
      trigger.addEventListener('click', (ev) => {
        ev.preventDefault();

        trigger.classList.toggle('o-readmore-btn--active');
        target.classList.toggle('o-readmore--active');

        const text = trigger.innerText;

        if (text.toLowerCase() === 'read more') {
          trigger.innerText = 'Read Less';
        } else if (text.toLowerCase() === 'read less') {
          trigger.innerText = 'Read More';
        }
      });

      // if we didn't set a hidden OR we did and the media query matches
      if (hidden === null || (hidden && mq.matches)) {
        setTimeout(() => {
          target.classList.remove('o-readmore--no-transition');
        }, 1000);
      }
    }
  });
}
